// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc7ab14d","453":"760ffba4","455":"54da26ff","977":"ab430465"}[chunkId] + ".chunk.js";
};